import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const getTemplates = async (filter = {}) => {
    /* if (!filter.extension) {
        filter.extension = ['VERSION_COUNT'];
    } */
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/template`,
        sessionToken: keeper('sessionToken'),
        data: filter,
    });
    return res;
};

export const getTemplate = async (templateId) => {
    let res = {},
        searchEndpoint = '/v2/template';

    if (templateId !== '0') {
        res = await r({
            endpoint: `${keeper('apiUrl')}/v2/template/${templateId}`,
            sessionToken: keeper('sessionToken'),
            method: 'get',
        });
    }

    res = await normalizeBySchema(searchEndpoint, 'post', res);
    return res;
};

export const getTemplateVersions = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/templateVersion`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getTemplateVersion = async (templateVersionId) => {
    let res = {},
        searchEndpoint = '/v2/templateVersion';

    if (templateVersionId !== '0') {
        res = await r({
            endpoint: `${keeper('apiUrl')}/v2/templateVersion/${templateVersionId}`,
            sessionToken: keeper('sessionToken'),
            method: 'get',
        });
    } else {
        res = await normalizeBySchema(searchEndpoint, 'post', res);
    }
    return res;
};

export const saveTemplateVersion = async (templateVersionId, data, saving = {}) => {
    let method = 'put',
        searchEndpoint = '/v2/templateVersion/{templateVersionId}',
        defaultTypeName = 'UpdateTemplateVersionRequest',
        endpoint = `${keeper('apiUrl')}/v2/templateVersion/${templateVersionId}`;

    if (templateVersionId === '0') {
        method = 'post';
        searchEndpoint = '/v2/templateVersion/{templateId}';
        // THIS WILL LIKELY CHANGE defaultTypeName = 'UpdateTemplateVersionRequest';
        endpoint = `${keeper('apiUrl')}/v2/templateVersion`;
    }

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;
    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;
    return res;
};

export const saveTemplate = async (templateId, data, saving = {}) => {
    let method = 'put',
        defaultTypeName = 'UpdateTemplateRequest',
        searchEndpoint = '/v2/template/{templateId}',
        endpoint = `${keeper('apiUrl')}/v2/template/${templateId}`;

    if (templateId === '0') {
        method = 'post';
        // THIS WILL LIKELY CHANGE defaultTypeName = 'UpdateTemplateRequest';
        searchEndpoint = '/v2/template';
        endpoint = `${keeper('apiUrl')}/v2/template`;
    }
    saving.active = true;
    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;
    return res;
};

export const getPreview = async (dataModel, saving = {}) => {
    let method = 'post',
        //defaultTypeName = 'UpdateTemplateRequest',
        //searchEndpoint = '/v2/external/document',
        endpoint = dataModel.duid
            ? `${keeper('apiUrl')}/v2/external/document`
            : `${keeper('apiUrl')}/v1/external/document`;
    saving.active = true;

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;
    return res;
};

export const sendPreview = async (dataModel, saving = {}) => {
    let method = 'post',
        //defaultTypeName = 'UpdateTemplateRequest',
        //searchEndpoint = '/v2/external/document',
        endpoint = dataModel.duid
            ? `${keeper('apiUrl')}/v2/external/emailDocument`
            : `${keeper('apiUrl')}/v1/external/emailDocument`;
    saving.active = true;

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;

    return res;
};

export const parseUiConfig = (uiConfig) => {
    return JSON.parse(uiConfig);
};

export const recoverFromSource = (templateVersionModel, _uiConfig, defaults) => {
    // Vytvoření DOM parseru
    const parser = new DOMParser();
    const doc = parser.parseFromString(templateVersionModel.source, 'text/html');
    if (!_uiConfig.template) {
        _uiConfig.template = {};
    }
    if (!_uiConfig.template.meta) {
        _uiConfig.template.meta = defaults.meta;
    }

    if (!_uiConfig.template.head) {
        _uiConfig.template.head = defaults.head;
    }

    if (!_uiConfig.template.body) {
        _uiConfig.template.body = [];
    }

    _uiConfig.template.meta.data.subject = templateVersionModel.subject;
    _uiConfig.template.meta.data.changeLog = templateVersionModel.changeLog;
    _uiConfig.template.meta.data.version = templateVersionModel.version;

    const tagDetect = ['author', 'description', 'keywords'];

    // Extract div meta tags with name and content attribute
    Array.from(doc.querySelectorAll('meta[name]')).forEach((tag) => {
        /* DETECTION CHECK
        console.log(
            'meta tag',
            tag.attributes.name.value,
            tag.attributes.content.value,
        ); */
        if (tagDetect.includes(tag.attributes.name.value)) {
            _uiConfig.template.meta.data[tag.attributes.name.value] = tag.attributes.content.value;
        }
    });

    _uiConfig.template.head.styles = '';
    // Extract style tags
    Array.from(doc.querySelectorAll('style')).forEach((tag) => {
        _uiConfig.template.head.styles += tag.outerHTML;
    });

    // Extract div with page-content
    Array.from(doc.querySelectorAll('div.page-header, div.page-content')).forEach((tag) => {
        _uiConfig.template.body.push({
            cols: [
                {
                    content: {
                        html: tag.innerHTML,
                        style: {},
                    },
                    style: {
                        width: '100%',
                    },
                },
            ],
        });
    });

    return _uiConfig;
};

export const isEmptyModel = (model) => {
    return Object.keys(model).length === 0;
};

export const useTemplates = () => {
    return {
        listTemplates: getTemplates,
        getTemplate: getTemplate,
        saveTemplate: saveTemplate,
        saveTemplateVersion: saveTemplateVersion,
        getTemplateVersion: getTemplateVersion,
        getTemplateVersions: getTemplateVersions,
        getPreview: getPreview,
        parseUiConfig: parseUiConfig,
        recoverFromSource: recoverFromSource,
        isEmptyModel: isEmptyModel,
    };
};

export default useTemplates;
